/* eslint-disable react/react-in-jsx-scope */

export default function About() {
  return (
    <div
      id="About"
      className="flex flex-col items-center bg-peach  md:flex-row  pt-16"
    >
      <div className="flex flex-col items-center justify-between p-8 leading-normal">
        <h5 className="mb-2 md:text-5xl text-3xl text-darkBrown font-headers">
          More About me!
        </h5>
        <p className="mb-3 md:mx-32 mx-8 font-normal italic font-semibold text-brown text-base text-xl">
          👋 I&apos;m Hayat, an enthusiastic full-stack developer, passionate
          about building well-designed and scalable websites, learning new
          things, taking on different challenges, and always trying to implement
          what I have learned.
          <br />
          <br />
          👩‍💻 Having 3+ years experience with Asp.Net and SQL servers world. My current job in Foothill Technology Solutions as a backend developer, allowed me to work with a well-organized and famous customer in the restaurant accounting sector in the US, Restaurant365.
          <br />
          <br />
          💫 My vision always is 👉 as a web developer, I have to learn how the
          web development world work, not only on the backend side, so I got the
          opportunity to build my skills in frontend development with Re:Coded.
          And officially now I&apos;m a Full-stack developer.
          <br />
          <br />
          💫 Always believing in&quot;helping people to learn and improve
          themselves is the indirect way of learning and improving your
          skills.&quot; that&apos;s why I&apos;m proud that I&apos;m a
          volunteer at Foothill Technology Solutions to mentor undergraduate
          students.
          <br />
          <br />
          🕹 My Technical skills: Asp.Net framework, SQL, React framework, HTML,
          CSS, JS, ORMs.
          <br />
          <br />
          ✨️ My Soft Skills: Problem-solving, Teamwork, Leadership, and
          Critical thinking.
        </p>
        <a href="https://www.canva.com/design/DAFM5q_Au6o/9RvvcMU80_yXXkcBvcm52g/edit?utm_content=DAFM5q_Au6o&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton"
        target="_blank" rel="noreferrer" >
          <button className="shadow-xl rounded-full bg-brown p-4 text-white">
            View my resume
          </button>
        </a>
      </div>
    </div>
  );
}
